module.exports = __webpack_public_path__ + "img/news_img1.1ee6f0a3.png";